import { VStack, Heading, Link, Button } from '@chakra-ui/react'
import React, {useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { NavLink, useRouteMatch } from 'react-router-dom'
import { UrlEndpointsHomeGraphic } from '../../../graphics/UrlEndpoints'
import { PermissionsEnum } from '../../../utils'
import PermissionGuard from '../../components/PermissionGuard'

const UrlEndpointsHome = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('url_endpoints', 'URL Endpoints')}</title>
        <meta name="description" content="URL Endpoints page" />
      </Helmet>
      <PermissionGuard
        permission={PermissionsEnum.SELF_INTEGRATION_MANAGE}
      >
        {
          (hasPermission: boolean) => (
            <VStack
              spacing={6}
              alignItems="center"
              justifyContent="center"
              height="full"
              width="full"
            >
              <UrlEndpointsHomeGraphic height={56} width={56} />
              <Heading as="h6" size="md" fontWeight="semibold">
                {
                  hasPermission ? 
                  t('create_new_endpoint', 'Create a new URL Endpoint') :
                  t('url_endpoints', 'URL endpoints')
                }
              </Heading>
              {
                hasPermission ? (
                  <Link
                    as={NavLink}
                    to={`${path}/new`}
                    _hover={{ textDecoration: 'none', outline: 'none' }}
                  >
                    <Button>{t('add_new', 'Add New')}</Button>
                  </Link>
                ) : null
              }
            </VStack>
          )
        }
      </PermissionGuard>
    </React.Fragment>
  )
}

export default UrlEndpointsHome
